import { render } from "./BtnPrimarioTransparente.vue?vue&type=template&id=44be32e6&scoped=true"
import script from "./BtnPrimarioTransparente.vue?vue&type=script&lang=js"
export * from "./BtnPrimarioTransparente.vue?vue&type=script&lang=js"

import "./BtnPrimarioTransparente.vue?vue&type=style&index=0&id=44be32e6&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44be32e6"]])

export default __exports__